export default "__VITE_ASSET__b1926dec__"